<template>
  <v-container wrap class="text-center">
    <v-progress-circular v-if="working" :size="70" :width="7" color="secondary" indeterminate
      class="mb-2"></v-progress-circular>
    <div :class="!isSmallerDisplay() ? 'centered' : ''">
      <v-card flat max-width="650px" light>
        <v-card-text v-if="updateCOF">
          <div class="text-h4">{{ memberName }}</div>
          <div class="text-subtitle-1">{{ $t("message.update_card_on_file") }}</div>
        </v-card-text>
        <div>
          <iframe v-show="!working" id="token-iframe" frameborder="0" :width="iframeWidth"
            :height="iframeHeight"></iframe>
          <input type="hidden" id="token" />
        </div>
        <v-list v-if="items && items.length > 0" class="text-left" outlined rounded>
          <v-list-item v-for="(i, index) in items" :key="'item_' + index" link dense>
            <v-list-item-content>
              <v-list-item-title class="text-left">
                {{ i.name }}
                <v-icon size="20" class="ml-1" v-if="i.recurrent">mdi-sync</v-icon>
                <v-icon size="20" class="ml-1" v-else-if="i.discount">mdi-tag-outline</v-icon>
              </v-list-item-title>
              <v-list-item-subtitle v-if="i.startDate" class="primary--text">
                {{ $t("message.starts") }} {{ $d(new Date(i.startDate), "month_day_year", $i18n.locale) }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content>
              <v-list-item-title v-if="i.discount" class="text-right">
                <span>-</span>
                <span v-if="i.percent > 0">%{{ i.percent }}</span>
                <span v-else>{{ currency }}{{ i.amount }}</span>
              </v-list-item-title>
              <v-list-item-title v-else class="text-right">
                <span v-if="!i.recurrent">{{ i.quantity }}</span>
                <span v-if="!i.recurrent" class="mr-1 ml-1">x</span>
                {{ currency }}{{ i.amount }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-text class="text-center text-h2" v-if="!working && !updateCOF">
          {{ currency }}{{ total }}
        </v-card-text>
        <v-card-actions v-if="!working" light>
          <v-btn outlined :disabled="paying || (total <= 0 && !updateCOF && !startsInFuture)" elevation="0" block
            color="secondary" class="pl-0 pr-0" @click="checkPaymentMethod()">
            <div v-if="!paying">
              <span v-if="updateCOF">UPDATE</span>
              <span v-else-if="startsInFuture && !willProcessNow">SAVE PAYMENT METHOD</span>
              <span v-else-if="startsInFuture && willProcessNow">SAVE PAYMENT METHOD & PAY NOW</span>
              <span v-else>PAY NOW</span>
            </div>
            <v-progress-linear v-else indeterminate color="success" size="50"></v-progress-linear>
          </v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-btn elevation="0" small block @click="cancelPayment()">Cancel</v-btn>
        </v-card-actions>
        <v-card outlined class="mt-2">
          <v-card-text>
            Test card VISA - <v-btn text @click="copyToClipboard('4761731000000043')">4761 7310 0000 0043</v-btn><br>
            CVV - 201<br>
            EXP: 12/26
          </v-card-text>
          <v-card-text>
            Test card MasterCard - <v-btn text @click="copyToClipboard('5413330089020060')">5413 3300 8902
              0060</v-btn><br>
            CVV - 201<br>
            EXP: 12/26
          </v-card-text>
        </v-card>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      transaction: {},
      working: true,
      memberName: null,
      updateCOF: false,
      inBackend: false,
      tokenKey: null,
      postData: { routeFrom: 'bulk' },
      total: 0,
      currency: '$',
      items: [],
      results: null,
      discount: null,
      newTransaction: false,
      subscriptionStartDate: null,
      paying: false,
      startsInFuture: false,
      willProcessNow: true,
      iframeWidth: '400px',
      iframeHeight: '250px'
    };
  },
  props: ["transactionData", "transactionId"],
  components: {
  },
  beforeDestroy() {
    /*eslint-disable no-undef*/
    DatacapHostedWebToken.removeMessageEventListener();
  },
  created() {
    if (this.isSmallerDisplay()) {
      this.iframeWidth = '300px';
      this.iframeHeight = '400px';
    }
    console.log(this.transactionData)
    if (this.transactionData && this.transactionData.items) {
      this.setupTransactionDisplayData(this.transactionData);
    } else if (this.transactionData && this.transactionData.memberId && this.transactionData.action == 'update-card') {
      this.updateCOF = true;
      this.memberName = this.transactionData.memberName;
    }
  },
  mounted() {
    this.initPayment();
  },
  methods: {
    setupTransactionDisplayData(transactionData, skipItems) {
      if (transactionData.product) {
        if (!this.items)
          this.items = [];
        const recurrent = transactionData.product.type == 'service' ? true : false
        this.items.push({
          name: transactionData.product.name,
          amount: transactionData.product.amountDecimal,
          quantity: 1,
          recurrent: recurrent,
          startDate: recurrent ? transactionData.subscriptionStartDate : null
        });
      }
      if (!skipItems) {
        let items = [];
        for (const i of transactionData.items) {
          items.push({
            name: i.name,
            amount: i.amountDecimal,
            quantity: i.quantity
          });
        }
        if (transactionData.discountAmount > 0) {
          items.push({
            name: this.$t("message.discount"),
            discount: true,
            amount: transactionData.discountAmount,
          });
        } else if (transactionData.discountPercent > 0) {
          items.push({
            name: this.$t("message.discount"),
            discount: true,
            percent: transactionData.discountPercent,
          });
        }

        if (transactionData.prorated && transactionData.prorated.amount) {
          items.push({
            name: this.$t("message.prorated_amount"),
            amount: transactionData.prorated.amount,
            quantity: 1,
          });
        }
        this.items = this.items.concat(items);
      }

      if (transactionData.subscriptionStartDate && transactionData.recurrence) {
        if (transactionData.prorated && transactionData.prorated.amount > 0)
          this.total = transactionData.prorated.amount;
        else
          this.total = 0;
        this.startsInFuture = true;
        this.willProcessNow = this.checkPaymentDates();
      } else if (transactionData.recurrence) {
        this.total = transactionData.recurrence.totalAmount;
      } else {
        this.total = transactionData.amount;
      }
    },
    checkPaymentDates() {
      let willProcessNow = true;
      if (this.startsInFuture) {
        const len = this.items.length;
        if (this.items && len > 0) {
          if (len == 1)
            willProcessNow = false;
          else if (len == 2 && (this.items[0].discount || this.items[1].discount))
            willProcessNow = false;
          //if there are more than 2 means there is prorated account + discount so willProcessNow  = true
        }
      }
      console.log('Will process in now: ', willProcessNow)
      return willProcessNow;
    },
    goToTransaction() {
      if (this.postData && this.postData.productId) {
        this.navigateTo({ name: 'viewtransaction', params: { sessionId: this.transaction._id } })
      } else if (this.transaction && this.transaction.product) {
        this.navigateTo({ name: 'viewtransaction', params: { sessionId: this.transaction._id } })
      } else {
        this.navigateTo({ name: 'viewitemstransaction', params: { transactionId: this.transaction._id } });
      }
    },
    async cancelPayment() {
      if (this.newTransaction) {
        //submit cancellation
        this.working = true;
        /*eslint-disable no-undef*/
        DatacapHostedWebToken.removeMessageEventListener();
        if (this.transaction && this.transaction._id) {
          await Api()
            .delete(
              "payments/academy/" +
              this.$store.state.managedAcademy +
              "/transactions/" +
              this.transaction._id
            ).catch(() => {
              this.working = false;
            });
        }
      }
      if (this.transactionData && this.transactionData.routeFrom) {
        if (this.transactionData.routeFrom == 'viewitemstransaction' && this.transactionId)
          this.navigateTo({ name: 'viewitemstransaction', transactionId: this.transactionId });
        else if (this.transactionData.routeFrom == 'viewtransaction' && this.transactionId)
          this.navigateTo({ name: 'viewtransaction', sessionId: this.transactionId });
        else if (this.transactionData.routeFrom == 'viewmember')
          this.navigateTo({ name: "viewmember", params: { memberid: this.transactionData.memberId } });
        else
          this.navigateTo({ name: this.transactionData.routeFrom });
      } else {
        this.navigateTo({ name: 'bulksell' });
      }
    },
    async initPayment() {
      this.working = true;
      try {
        const isConnected = await Api()
          .get(
            "payments/v3/managedacademy/" +
            this.$store.state.managedAcademy +
            "/is_connected/infinicept"
          );
        if (isConnected.data.infiniceptConnected && isConnected.data.token) {
          this.tokenKey = isConnected.data.token;
          if (this.transactionId || this.transaction._id) {
            if (!this.transaction._id)
              this.transaction._id = this.transactionId;
            const t = await Api()
              .get(
                "payments/v3/managedacademy/" +
                this.$store.state.managedAcademy +
                "/transaction/" +
                this.transaction._id
              );
            //TODO, load complete and ask for card once we have the ID
            const transactionData = t.data ? t.data.transaction : null;
            if (transactionData) {
              this.transaction = transactionData;
              console.log('HERE')
              this.setupTransactionDisplayData(transactionData);
            }
          } else if (this.transactionData.action != 'update-card') {
            //We are starting a new one
            this.postData = this.transactionData;
            this.newTransaction = true;
            if (this.postData) {
              if (this.postData && this.postData.currency)
                this.currency = this.postData.currency;
              const newTransaction = await Api()
                .post(
                  "payments/v3/managedacademy/" +
                  this.$store.state.managedAcademy +
                  "/transaction/init", this.postData
                );
              if (newTransaction.data && newTransaction.data.transaction) {
                this.transaction = newTransaction.data.transaction;
                if (this.postData.sendNotification) {
                  this.goToTransaction();
                }
              }
              if (this.transaction) {
                this.setupTransactionDisplayData(this.transaction, true);//Skip items cuz they were passed to the component
              }
            } else {
              this.cancelPayment();
            }
          }
          /*eslint-disable no-undef*/
          DatacapHostedWebToken.init(this.tokenKey, 'token-iframe', this.completePayment);
          //call init checkout and then ... 
          this.working = false;
        } else {
          this.showAlert("error", "Payments modeule not connected");
        }
      } catch (err) {
        console.log(err)
        this.showAlert("error", this.$t("message.error_generic"));
      }
    },
    checkPaymentMethod() {
      this.paying = true;
      /*eslint-disable no-undef*/

      DatacapHostedWebToken.requestToken();
    },
    async completePayment(response) {
      if (this.inBackend)
        return;
      if (response.Error) {
        // Handle tokenization errors
        let error = response.Error;
        this.paying = false;
        this.showAlert("error", error);
        console.log('Error: ', error);
      } else {
        const token = response.Token;
        this.results = response;
        let data = {
          token: token
        };
        this.inBackend = true;
        if (this.updateCOF) {
          if (!this.transactionData.memberId) {
            this.paying = false;
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            return;
          }
          Api()
            .post(
              "payments/v3/managedacademy/" +
              this.$store.state.managedAcademy +
              "/member/" + this.transactionData.memberId + "/cc/update",
              data
            )
            .then((response) => {
              if (response.data) {
                const data = response.data.data;
                if (data.status == "Approved" && data.gatewayId) {
                  /*eslint-disable no-undef*/
                  DatacapHostedWebToken.removeMessageEventListener();
                  //back to transaction page
                  const vm = this;
                  setTimeout(function () {
                    vm.goToMember(vm.transactionData.memberId);
                  }, 1000);
                } else {
                  this.paying = false;
                  this.showAlert("error", this.$t("message.error_generic"));
                }
                this.inBackend = false;
                DatacapHostedWebToken.removeMessageEventListener();
                DatacapHostedWebToken.init(this.tokenKey, 'token-iframe', this.completePayment);
              }
            })
            .catch((err) => {
              this.inBackend = false;
              this.paying = false;
              this.showAlert("error", err.response.data.message);
              /*eslint-disable no-undef*/
              DatacapHostedWebToken.removeMessageEventListener();
              DatacapHostedWebToken.init(this.tokenKey, 'token-iframe', this.completePayment);
            });
        } else {
          if (!this.transaction._id) {
            this.paying = false;
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            return;
          }
          Api()
            .post(
              "payments/v3/managedacademy/" +
              this.$store.state.managedAcademy +
              "/transaction/" +
              this.transaction._id +
              "/pay",
              data
            )
            .then((response) => {
              if (response.data) {
                const data = response.data.data;
                if (data.status == "Approved" && data.gatewayId) {
                  /*eslint-disable no-undef*/
                  DatacapHostedWebToken.removeMessageEventListener();
                  //back to transaction page
                  const vm = this;
                  setTimeout(function () {
                    vm.goToTransaction();
                  }, 1000);
                } else {
                  this.paying = false;
                  this.showAlert("error", this.$t("message.error_generic"));
                }
                this.inBackend = false;
                DatacapHostedWebToken.removeMessageEventListener();
                DatacapHostedWebToken.init(this.tokenKey, 'token-iframe', this.completePayment);
              }
            })
            .catch((err) => {
              this.inBackend = false;
              this.paying = false;
              this.showAlert("error", err.response.data.message);
              /*eslint-disable no-undef*/
              DatacapHostedWebToken.removeMessageEventListener();
              DatacapHostedWebToken.init(this.tokenKey, 'token-iframe', this.completePayment);
            });
        }
        //window.alert("Token received: \n" + JSON.stringify(response, null, 2));
      }
    }
  }
};
</script>

<style scoped>
.centered div {
  margin-left: auto;
  margin-right: auto;
}
</style>